import Marquee from "react-fast-marquee";

export default function EditorialMarquee() {
  const items = [
    "Aesthetic Prompts",
    "Ebooks",
    "Cookbooks",
    "Brand Merch",
    "Home Goods",
    "Tiny Tunes Dancer",
    "Affiliate Picks",
    "Remedies",
  ];
  return (
    <div
      data-testid="editorial-marquee"
      className="bg-[#2C2924] text-[#FDFBF7] py-8 border-y border-[#D4AF37]/30 overflow-hidden"
    >
      <Marquee speed={40} gradient={false} pauseOnHover>
        {items.map((it, i) => (
          <span key={`${it}-${i}`} className="font-serif italic text-2xl md:text-3xl mx-16 text-[#F3E5AB]">
            {it}
            <span className="mx-12 text-[#D4AF37]">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
